// Generated types for RFLPTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI } from '../../shared/types/neonode';
import { PDMProductWriteAPI } from '../../pdm/types/pdmproduct';
import { ProjectWriteAPI } from '../../rflp/types/project';
import { TaskReadAPI, TaskWriteAPI } from '../../tasks/types/task';
import { ThreadWriteAPI } from '../../chat/types/thread';
import { NeoNodeReadAPISchema } from '../../shared/types/neonode';
import { PDMProductWriteAPISchema } from '../../pdm/types/pdmproduct';
import { ProjectWriteAPISchema } from '../../rflp/types/project';
import { TaskReadAPISchemaObject, TaskWriteAPISchemaObject } from '../../tasks/types/task';
import { ThreadWriteAPISchema } from '../../chat/types/thread';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface RFLPTaskReadAPI extends TaskReadAPI {
  /** Completeness stages with work not yet gated clean. Server-internal bookkeeping for the finish-turn gate. */
  pending_gate_stages?: string[] | null;
}

export interface RFLPTaskWriteAPI extends TaskWriteAPI {
  thread?: string | ThreadWriteAPI;
  currently_attached_to?: string | PDMProductWriteAPI | ProjectWriteAPI;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const RFLPTaskReadAPISchema: z.ZodType<RFLPTaskReadAPI> = TaskReadAPISchemaObject.extend({
  pending_gate_stages: z.array(z.string()).nullable().optional(),
}).passthrough();

export const RFLPTaskWriteAPISchema: z.ZodType<RFLPTaskWriteAPI> = TaskWriteAPISchemaObject.extend({
  thread: z.union([z.string(), z.lazy(() => ThreadWriteAPISchema)]).optional(),
  currently_attached_to: z.union([z.string(), z.lazy(() => PDMProductWriteAPISchema), z.lazy(() => ProjectWriteAPISchema)]).optional(),
}).passthrough();
